import createCachedSelector from 're-reselect';
import { denormalize } from 'normalizr';
import * as actions from '../actions/actionCreators/reportsActions';
import schemas from '../utils/schemas';

const ids = (filters, page, pageSize, state) => {
  const key = actions.loadReportsKey(filters, pageSize);
  const reports = state.reports.list[key];
  if (!reports) {
    return [];
  }

  const result = reports[page] ? reports[page].ids : [];
  return result ? result : [];
};

const reports = (filters, page, pageSize, state) => (state.reports.entities.reports ? state.reports.entities.reports : []);

export const getReports = createCachedSelector(ids, reports, (ids, reports) => ids.map(id => reports[id]))(
  // eslint-disable-next-line no-unused-vars
  (filters, page, pageSize, state) => actions.loadReportsKey(filters, pageSize)
);

export const getReportsLoading = (filters, page, pageSize, state) => {
  const key = actions.loadReportsKey(filters, pageSize);
  const reports = state.reports.list[key];
  const loading = reports && reports[page] ? reports[page].loading : false;
  return loading;
};

export const getReportTotalCount = (filters, pageSize, state) => {
  const key = actions.loadReportsKey(filters, pageSize);
  const reports = state.reports.list[key];
  const count = reports && reports.totalCount ? reports.totalCount : 0;
  return count;
};

export const getReport = (reportId, state) => {
  const reportItem = state.reports.items[reportId];
  if (reportItem && reportItem.loaded) {
    const report = denormalize(reportId, schemas.report, state.reports.entities);
    return report;
  }

  return null;
};

export const getReportLoading = (reportId, state) => {
  return state.reports.items[reportId] && state.reports.items[reportId].loading;
};

export const getReportLoaded = (reportId, state) => {
  return state.reports.items[reportId] && state.reports.items[reportId].loaded;
};

export const getReportGenerating = (reportId, state) => {
  return state.reports.items[reportId] && state.reports.items[reportId].generating;
};

export const getBrowser = (browserId, state) => {
  const browserItem = state.reports.browserItems[browserId];
  if (browserItem && browserItem.loaded) {
    const browser = denormalize(browserId, schemas.browser, state.reports.entities);
    return browser;
  }
};

export const getBrowserLoading = (browserId, state) => {
  return state.reports.browserItems[browserId] && state.reports.browserItems[browserId].loading;
};

export const getBrowserLoaded = (browserId, state) => {
  return state.reports.browserItems[browserId] && state.reports.browserItems[browserId].loaded;
};

const browserDataIds = (browserId, page, pageSize, filters, order, orderBy, state) => {
  const key = actions.loadBrowserDataKey(filters, pageSize, order, orderBy);
  const browserData = state.reports.browserDataList[browserId] && state.reports.browserDataList[browserId][key];
  if (!browserData) {
    return [];
  }

  const result = browserData[page] ? browserData[page].ids : [];
  return result ? result : [];
};

const browserData = (browserId, page, pageSize, filters, order, orderBy, state) =>
  state.reports.browserData[browserId] ? state.reports.browserData[browserId] : [];

export const getBrowserData = createCachedSelector(browserDataIds, browserData, (browserDataIds, browserData) =>
  browserDataIds.map(id => browserData[id])
)(
  // eslint-disable-next-line no-unused-vars
  (browserId, filters, page, pageSize, order, orderBy, state) => actions.loadBrowserDataKey(filters, pageSize, order, orderBy)
);

export const getBrowserDataTotalCount = (browserId, filters, pageSize, order, orderBy, state) => {
  const key = actions.loadBrowserDataKey(filters, pageSize, order, orderBy);
  const browserData = state.reports.browserDataList[browserId] && state.reports.browserDataList[browserId][key];
  const count = browserData && browserData.totalCount ? browserData.totalCount : 0;
  return count;
};

export const getBrowserDataLoading = (browserId, page, pageSize, filters, order, orderBy, state) => {
  const key = actions.loadBrowserDataKey(filters, pageSize, order, orderBy);
  const browserData = state.reports.browserDataList[browserId] && state.reports.browserDataList[browserId][key];
  const loading = browserData && browserData[page] ? browserData[page].loading : false;
  return loading;
};

export const getBrowserDataLoaded = (browserId, page, pageSize, filters, order, orderBy, state) => {
  const key = actions.loadBrowserDataKey(filters, pageSize, order, orderBy);
  const browserData = state.reports.browserDataList[browserId] && state.reports.browserDataList[browserId][key];
  const loaded = browserData && browserData[page] ? browserData[page].loaded : false;
  return loaded;
};
